// extracted by mini-css-extract-plugin
module.exports = {"Caution":"ConfirmPopup_Caution_34SsH","Warning":"ConfirmPopup_Warning_W2QKj","ButtonDiv":"ConfirmPopup_ButtonDiv_xwEQz","ConfirmPopupDiv":"ConfirmPopup_ConfirmPopupDiv_13mxH"};